import { render, staticRenderFns } from "./SlTaxDocumentList.vue?vue&type=template&id=c19b2810&lang=pug&"
import script from "./SlTaxDocumentList.vue?vue&type=script&lang=js&"
export * from "./SlTaxDocumentList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SlTaxDocumentList.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib'
installComponents(component, {
  VIcon,
})
